import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';

export class ReportRepository {
  private api: any;
  private configService: any;
  private tgSocialService: any;
  private tgSocialBase: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.tgSocialService = runtimeConfig.public.apiTGSocialService;
    this.tgSocialBase = runtimeConfig.public.apiTGSocialBase;
  }

  async getReportList(
    params: any
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/summary-report/monthly`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async getUsageReportList(
    params: any
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/summary-report/usage`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async getChatHistoryReport(
    params: any
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/summary-report/chat-history`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }
}